"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_DOCUMENT_FIELDS = exports.GetDocumentsFilterBy = exports.DocumentPaymentStatus = exports.DocumentSource = void 0;
var DocumentSource;
(function (DocumentSource) {
    DocumentSource["CLOSURE"] = "CLOSURE";
    DocumentSource["COMMISSION_PLAN"] = "COMMISSION_PLAN";
    DocumentSource["PAYROLL"] = "PAYROLL";
    DocumentSource["PAYMENT_REQUEST"] = "PAYMENT_REQUEST";
})(DocumentSource = exports.DocumentSource || (exports.DocumentSource = {}));
var DocumentPaymentStatus;
(function (DocumentPaymentStatus) {
    DocumentPaymentStatus["ALL"] = "ALL";
    DocumentPaymentStatus["PAID"] = "PAID";
    DocumentPaymentStatus["PENDING"] = "PENDING";
})(DocumentPaymentStatus = exports.DocumentPaymentStatus || (exports.DocumentPaymentStatus = {}));
var GetDocumentsFilterBy;
(function (GetDocumentsFilterBy) {
    GetDocumentsFilterBy["CLOSURE_DATE"] = "CLOSURE_DATE";
    GetDocumentsFilterBy["CREATION_DATE"] = "CREATION_DATE";
})(GetDocumentsFilterBy = exports.GetDocumentsFilterBy || (exports.GetDocumentsFilterBy = {}));
exports.SORTABLE_DOCUMENT_FIELDS = [
    'created_at',
    'name',
    'date',
    'approval',
    'paid_at',
    'nome_credor',
];
